// extracted by mini-css-extract-plugin
export default {"logo":"MainPageLogo_logo__zHX2S","logo__image":"MainPageLogo_logo__image__PnD2h","scale-logo":"MainPageLogo_scale-logo__q31Fm"};